import React from 'react';
import { ReactComponent as FigUsers02Component } from './FigUsersCheck.svg';

const FigUsersCheck = (props) => <FigUsers02Component {...props} />;

export default FigUsersCheck;
